export default __webpack_public_path__ + "static/media/barrels.88c428df.png";